import React from "react";

// Material UI Components
import Popover from "@mui/material/Popover";
import DialogActions from "@mui/material/DialogActions";

import Button from "components/buttons/Button/Button.component";
import FilterDrawer from "features/inventory/components/FilterDrawer/FilterDrawer.component";
import SearchButton from "features/inventory/components/SearchButton/SearchButton.component";
import LocationForm from "features/inventory/components/LocationForm/LocationForm.component";

// Styles
import { useStyles } from "./LocationPopup.styles";

const LocationPopup = ({
  clearInventoryCards,
  popoverOpen,
  drawerOpen,
  handleClose,
  anchorEl,
  listingsCount,
  locationFormProps,
}) => {
  const classes = useStyles();

  return (
    <>
      <Popover
        classes={{ paper: classes.modalContents }}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={popoverOpen}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <LocationForm
          clearInventoryCards={clearInventoryCards}
          locationFormProps={locationFormProps}
        />
        <DialogActions className={classes.modalActions}>
          <Button onClick={handleClose} variant="text" size="lg">
            Cancel
          </Button>
          <div className="flexGrow" />
          <SearchButton listingsCount={listingsCount} onClick={handleClose} />
        </DialogActions>
      </Popover>
      <FilterDrawer
        open={drawerOpen}
        handleClose={handleClose}
        title="Edit"
        contents={
          <LocationForm
            clearInventoryCards={clearInventoryCards}
            locationFormProps={locationFormProps}
          />
        }
        actionMenuContents={
          <>
            <Button onClick={handleClose} variant="text" size="lg">
              Cancel
            </Button>
            <div className="flexGrow" />
            <SearchButton
              listingsCount={listingsCount}
              onClick={handleClose}
              data-cy="save-location-modal"
            />
          </>
        }
      />
    </>
  );
};

export default LocationPopup;
